import angular from 'angular';
import ProductsPageToolboxDirective from './products-page-toolbox.directive';

let ProductsPageToolboxModule = angular.module('catalog.productsList.productsPageToolbox', [])
 .directive('productsPageToolbox', ProductsPageToolboxDirective);

export default ProductsPageToolboxModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/products-list/products-page-toolbox/products-page-toolbox.js
 **/